/* Карусель вертикальних відео (кроки + відео-відгуки), 22.09.2026.
   - на телефоні/планшеті: слайди по центру, безкінечна прокрутка (клони першого/останнього по краях,
     на кінці — миттєвий стрибок на справжній слайд), крапки;
   - на ПК: звичайна сітка, клони сховані CSS ([data-clone]);
   - Play: клік — грає зі звуком, кнопка ховається; повторний клік по відео — пауза; інші відео ставить на паузу. */
(function () {
  if (window.__gzVideoCarousel) return;
  window.__gzVideoCarousel = true;

  function initTrack(track) {
    var slides = [].slice.call(track.children);
    var n = slides.length;
    if (n < 2) return;
    var dots = track.parentNode.querySelector('[data-gz-dots]');
    var ds = [];
    if (dots) {
      slides.forEach(function () { ds.push(dots.appendChild(document.createElement('i'))); });
    }

    // клони по краях для безкінечної прокрутки
    var firstClone = slides[0].cloneNode(true), lastClone = slides[n - 1].cloneNode(true);
    firstClone.setAttribute('data-clone', ''); lastClone.setAttribute('data-clone', '');
    track.insertBefore(lastClone, slides[0]);
    track.appendChild(firstClone);
    var all = [].slice.call(track.children); // n + 2

    function isScroll() { return getComputedStyle(track).overflowX === 'auto' || getComputedStyle(track).overflowX === 'scroll'; }
    function leftOf(el) { return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft; }
    function targetFor(i) { return leftOf(all[i]) + all[i].offsetWidth / 2 - track.clientWidth / 2; }
    function goTo(i, smooth) {
      track.style.scrollBehavior = smooth ? 'smooth' : 'auto';
      track.scrollLeft = targetFor(i);
    }
    function nearest() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      all.forEach(function (s, i) { var d = Math.abs(leftOf(s) + s.offsetWidth / 2 - c); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function markDots(i) { var r = ((i - 1) % n + n) % n; ds.forEach(function (d, k) { d.classList.toggle('is-active', k === r); }); }

    var settle;
    function onSettle() {
      if (!isScroll()) return;
      var i = nearest();
      if (i === 0) { goTo(n, false); i = n; }
      else if (i === n + 1) { goTo(1, false); i = 1; }
      markDots(i);
    }
    track.addEventListener('scroll', function () {
      markDots(nearest());
      clearTimeout(settle); settle = setTimeout(onSettle, 120);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', onSettle);

    function reset() { if (isScroll()) { goTo(1, false); markDots(1); } }
    reset();
    window.addEventListener('resize', function () { clearTimeout(settle); settle = setTimeout(reset, 150); });
    // після завантаження постерів розміри можуть змінитись — ще раз вирівняти
    window.addEventListener('load', reset);
  }

  document.querySelectorAll('[data-gz-carousel]').forEach(initTrack);

  // Play / pause
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('[data-gz-video]'); if (!wrap) return;
    var v = wrap.querySelector('video'); if (!v) return;
    if (v.paused) {
      document.querySelectorAll('[data-gz-video] video').forEach(function (x) {
        if (x !== v) { x.pause(); x.closest('[data-gz-video]').classList.remove('is-playing'); }
      });
      v.muted = false;
      v.play().catch(function () { v.muted = true; v.play(); });
      wrap.classList.add('is-playing');
    } else {
      v.pause(); wrap.classList.remove('is-playing');
    }
  });
})();
